document.addEventListener('DOMContentLoaded', () => {
	const links = document.querySelectorAll('a[data-service]')
	const formFields = document.querySelectorAll('form input[name="Service"]')

	if (formFields) {
		links.forEach(link => {
			link.addEventListener('click', () => {
				formFields.forEach(field => {
					if (field.value.toLowerCase() == link.dataset.service) {
						field.checked = true
					} else {
						field.checked = false
					}
				})
			})
		})
	}
})
